module.exports = __webpack_public_path__ + "static/media/contactsYellow.50bfcd05.svg";